import type { PedigreeType } from '@application/types';
import { countrySelectOptions, useRouter } from '@application/utils';
import type { CountryCode } from '@gql/graphql';
import {
  FiltersWithModalInputSelectField,
  FiltersWithModalInputWrapper,
} from '@presentation/components';
import { BREAKPOINTS } from '@presentation/styles';
import { Form } from 'formik';
import type { FC } from 'react';
import { useMediaQuery } from 'react-responsive';
import type { FiltersProps } from './types';

export const Filters: FC<FiltersProps> = (props) => {
  const { options } = props;

  const { translate, countryCode } = useRouter();

  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.tablet}px)` });

  const countryOptions = countrySelectOptions(translate);

  return (
    <Form>
      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<CountryCode>
          relativeDropdown={isMobile}
          name="countries"
          placeholder={translate('common.inputs.country.placeholder')}
          multiple
          dismissOnClick={false}
          options={countryOptions}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<string>
          name="regions"
          multiple
          dismissOnClick={false}
          placeholder={translate(`common.inputs.regions.placeholder.${countryCode}`)}
          relativeDropdown={isMobile}
          options={options.regions}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<string>
          name="breedNames"
          placeholder={translate('common.inputs.breeds.placeholder')}
          multiple
          dismissOnClick={false}
          options={options.breeds}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<PedigreeType>
          name="pedigree"
          placeholder={translate('common.inputs.pedigree.placeholder')}
          multiple
          options={[
            { value: 'FCI', label: translate('enum.pedigreeType.FCI') },
            { value: 'OTHER', label: translate('enum.pedigreeType.OTHER') },
          ]}
        />
      </FiltersWithModalInputWrapper>

      <FiltersWithModalInputWrapper>
        <FiltersWithModalInputSelectField<boolean>
          name="champion"
          placeholder={translate('common.inputs.champion.placeholder')}
          options={[
            { value: true, label: translate('enum.yesNoUnknownStatus.YES') },
            { value: false, label: translate('enum.yesNoUnknownStatus.NO') },
          ]}
        />
      </FiltersWithModalInputWrapper>
    </Form>
  );
};
